import { requestWithToken } from "../utils/apis";

export const updateToken = async (payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/api/user/update/token`,
      payload
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const userList = async (page, limit) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/user/list?page_no=${page}&page_size=${limit}`,
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const createUser = async (payload) => {
  try {
    const response = await requestWithToken(
      "POST",
      `/api/user/create`,
      payload
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const getUserDetails = async (id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/user/${id}`,
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const updateUser = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/api/user/${id}`,payload,
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const activateUser = async (id) => {
  try {
    const response = await requestWithToken(
      "PUT",
        `/api/user/${id}/activate`,
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const deactivateUser = async (id) => {
  try {
    const response = await requestWithToken(
      "DELETE",
        `/api/user/${id}`,
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
